'use strict';

import angular from 'angular';
import * as uiRouter from '@uirouter/angularjs';
import angularTranslate from 'angular-translate';
import angularCookies from 'angular-cookies';
import bootstrap from 'angular-ui-bootstrap';
import 'angular-translate-storage-cookie';
import 'angular-translate-loader-static-files';
//css
import '../assets/styles/styles.css';
import angularCSS from 'angular-css';

import components from './components';
import services from './services';

const dependencies = [
    uiRouter.default,
    angularTranslate,
    angularCookies,
    bootstrap,
    angularCSS
];

var app = angular.module('app', dependencies);
components(app);
services(app);

// main configuration
app.config(['$urlServiceProvider', '$translateProvider', '$locationProvider', '$sceDelegateProvider', '$compileProvider', function($urlServiceProvider, $translateProvider, $locationProvider, $sceDelegateProvider, $compileProvider){

    $urlServiceProvider.rules.otherwise({ state: 'home'});  // set default view
    $locationProvider.hashPrefix('');   //use '/#/' instead of '/#!/'

    $compileProvider.aHrefSanitizationTrustedUrlList(/^\s*(https?|s?ftp|mailto|tel|file|runstore):/);

    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        'https://*.shoppermx.io/**'
    ]);

    //setup translation service
    var fileNameConvention = {
        prefix: 'locales/',
        suffix: '.json'
    };
    // map different locales to available languages
    var defaultLanguage = 'en-US';
    var langMap = {
        'ar-AE': 'ar-AE',
        'ar-SA': 'ar-SA',
        'cs-CZ': 'cs-CZ',
        'en-US': 'en-US',
        'en-GB': 'en-GB',
        'es-CO': 'es-CO',
        'da-DK': 'da-DK',
        'de-DE': 'de-DE',
        'es-MX': 'es-MX',
        'es-ES': 'es-ES',
        'fr-CA': 'fr-CA',
        'fr-FR': 'fr-FR',
        'it-IT': 'it-IT',
        'hu-HU': 'hu-HU',
        'ko-KR': 'ko-KR',
        'ms-MY': 'ms-MY',
        'ms-SG': 'ms-SG',
        'nl-NL': 'nl-NL',
        'pl-PL': 'pl-PL',
        'pt-BR': 'pt-BR',
        'pt-PT': 'pt-PT',
        'ro-RO': 'ro-RO',
        'ru-RU': 'ru-RU',
        'sk-SK': 'sk-SK',
        'th-TH': 'th-TH',
        'tr-TR': 'tr-TR',
        'zh-CN': 'zh-CN',
        'zh-HK': 'zh-HK',
        'es-AR': 'es-AR',
        'es-CL': 'es-CL',
        'es-CR': 'es-CR',
        'es-PE': 'es-PE',
        'id-ID': 'id-ID',
        'ja-JP': 'ja-JP',
        'lt-LT': 'lt-LT',
        'lv-LV': 'lv-LV',
        'tl-PH': 'tl-PH',        
        'vi-VN': 'vi-VN',        
        'zh-TW': 'zh-TW',  
        'sv-SE': 'sv-SE',  
        '*' : defaultLanguage // Fallback language
    };
    var langRegistrations = Object.keys(langMap);
    langRegistrations.pop(); // remove "*"

    $translateProvider
        .useStaticFilesLoader(fileNameConvention)
        .registerAvailableLanguageKeys(langRegistrations, langMap)
        .useSanitizeValueStrategy('escape');

    $translateProvider.preferredLanguage(defaultLanguage);
    $translateProvider.forceAsyncReload(true);
    $translateProvider.useCookieStorage();
}]);

app.run(['$window', '$rootScope', function($window, $rootScope) {

    // warn if refreshing or closing window
    $window.addEventListener('beforeunload', function(e) {
        if (shouldWarnBeforeUnload(event)) {
            e = e || window.event;
            e.returnValue = '';
            return '';
        }
    });

    //setup window messaging (useful for cross-iframe messaging --> ng-js bridge)
    var eventMethod = $window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = $window[eventMethod];

    var messageEvent = (eventMethod === "attachEvent") ? "onmessage" : "message";

    eventer(messageEvent, function (e) {
        $rootScope.$broadcast('message', e);
    }, false);

    //setup window close prevention
    $rootScope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
        $rootScope.lastLocation = oldUrl;
    });

    $rootScope.$on('$locationChangeStart', function (event, newUrl) {
        if ($rootScope.lastLocation === newUrl) {
            event.preventDefault();
        }
    });

    var shouldWarnBeforeUnload = function (event) {

        // safety check to prevent ie11 errors in app insights.
        if (typeof event.target.URL === "object") {
            return false;
        } else {
            var url = event.target.URL.toLowerCase();
            return url.indexOf("complete") === -1 
                && url.indexOf("error") === -1
                && url.indexOf("redirect") === -1
                && url.indexOf("deciphersurvey") === -1
                && url.indexOf("modelview") === -1;
        }
    };
}]);